import React from 'react';

function StarsSvg({ children, width, height }) {
  width = width || 140;
  height = height || 26;
  return (
    <svg
      className="starSvg ml-3"
      width={width}
      height={height}
      viewBox="0 0 140 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0L17.1432 8.98278H27.3148L19.0858 14.5344L22.229 23.5172L14 17.9656L5.77101 23.5172L8.9142 14.5344L0.685208 8.98278H10.8568L14 0Z"
        fill="#800020"
      />
      <path
        d="M42 0L45.1432 8.98278H55.3148L47.0858 14.5344L50.229 23.5172L42 17.9656L33.771 23.5172L36.9142 14.5344L28.6852 8.98278H38.8568L42 0Z"
        fill="#800020"
      />
      <path
        d="M70 0L73.1432 8.98278H83.3148L75.0858 14.5344L78.229 23.5172L70 17.9656L61.771 23.5172L64.9142 14.5344L56.6852 8.98278H66.8568L70 0Z"
        fill="#800020"
      />
      <path
        d="M98 0L101.143 8.98278H111.315L103.086 14.5344L106.229 23.5172L98 17.9656L89.771 23.5172L92.9142 14.5344L84.6852 8.98278H94.8568L98 0Z"
        fill="#800020"
      />
      <path
        d="M126 0L129.143 8.98278H139.315L131.086 14.5344L134.229 23.5172L126 17.9656L117.771 23.5172L120.914 14.5344L112.685 8.98278H122.857L126 0Z"
        fill="#220000"
      />
    </svg>
  );
}

export default StarsSvg;
